import AiImage from 'src/views/ai-image';
import { isFunctionalityAllowed as ifa } from '../../../../editor/facade/restrictions/restrictions';

const BaseView = require('../components/common/common-component');
const SocialMediaView = require('./social-media');
const GradientsView = require('./gradients/view');
const AnalyticsDecorate = require('../../../analytics/decorate');
const CompanyFactory = require('../../../factory/company').instance;

module.exports = AnalyticsDecorate(require('./analytics/view'), BaseView.extend({
  type: 'image',
  memberType: ['images', 'brand'],
  uploadViewKey: 'image-import',
  StockView: require('./stock'),

  events: {
    ...BaseView.prototype.events,
    'click .ai-image-cta button': 'renderAIApp'
  },

  isAlreadyThere: function () {
    return !!this.$el.find('.tab-content.image').length;
  },

  render: async function () {
    const features = await CompanyFactory.getCompanyItems('features');
    const isStockEnabled = !!features?.white_label?.includes?.('show_marketplace') && ifa('function_use_web_images') && ifa('function_use_web_images');
    const canUseOwnImages = ifa('function_use_own_images');

    await BaseView.prototype.render.call(this);
    const fallbackTab = this._getFallbackTab(isStockEnabled, canUseOwnImages);

    if (this.isEnterprise) {
      let $myLibraryTab = this.$headerLinks.filter('[data-key=user_library]');

      if (!$myLibraryTab.length) $myLibraryTab = this.$headerLinks.filter('[data-key=library]');

      fallbackTab.length
        ? BaseView.prototype.checkEmptyLibrary.call(this, fallbackTab)
        : $myLibraryTab.trigger('click');
    } else {
      fallbackTab.trigger('click');
    }
  },

  renderAIApp: async function () {
    const workspace = await INKIVE.CompanyFactory.getCompanyData();
    const workspaceAllowsUpselling = workspace?.features?.users?.includes('allows_user_upselling');
    const isProPaidUser = INKIVE.UserInfoFactory.isProPaidUser();
    const isWorkspaceUser = INKIVE.UserInfoFactory.isBusinessUser();
    const isWorkspaceAllowed = isWorkspaceUser && !workspace.is_customisation_preview;

    if (!INKIVE.UserInfoFactory.hasContentPlan() && workspaceAllowsUpselling) {
      INKIVE.Helpers.displaySubscriptionModal(null, 'content2');
      return;
    }

    (isProPaidUser || isWorkspaceAllowed)
      ? AiImage.mountApp()
      : INKIVE.Helpers.displaySubscriptionModal();
  },

  _getFallbackTab: function (isStockEnabled, canUseOwnImages) {
    const stockTab = this.$headerLinks.filter('[data-key=stock]');
    const addTab = this.$headerLinks.filter('[data-key=add]');
    const libraryTab = this.$headerLinks.filter('[data-key=library]');
    const assetTab = this.$headerLinks.filter('[data-key=user_library]');

    if (!isStockEnabled) stockTab.hide();
    if (!canUseOwnImages) {
      assetTab.hide();
      addTab.hide();
    }

    if (stockTab?.length && isStockEnabled) return stockTab;
    if (addTab?.length && canUseOwnImages) return addTab;
    if (libraryTab?.length) return libraryTab;
    if (assetTab?.length && canUseOwnImages) return assetTab;

    return addTab;
  },

  initAddView: function () {
    BaseView.prototype.initAddView.call(this);

    const $socialMedia = $('<div class="social-media"/>');
    const socialMediaView = new SocialMediaView({
      el: $socialMedia,
      isAssetBankCompany: this.isAssetBankCompany
    });

    this.isAssetBankCompany && this.$el.find('.import-button').css('margin-top', 15);
    this.registerTabView('add', socialMediaView);
    socialMediaView.render();

    this.$el.find('.tab-content > .add .top-content').after($socialMedia);
    this.$el.find('.list-import-button').on('click', () => { this.$el.find('input[type=file]').click(); });
  },

  initGradientsView: function () {
    const $view = $('<div></div>');
    this.$el.find('.tab-content > .gradients').append($view);

    this.gradientsView = new GradientsView({ el: $view });
    this.registerTabView('gradients', this.gradientsView);
    this.gradientsView.show();
  },

  updateSearchContainer: function () {
    if (this.selectedTab.key === 'add') {
      this.selectedTab.searchable = false;
    }
    if (this.selectedTab.key === 'stock') {
      this.$el.find('.ai-image-cta').show();
    }

    this.selectedTab.searchable &&
      this.displaySearchContainer(this.$el.find('.search-container'));
  }
}));
